import CommonLookupDisplay from "components/CommonLookupDisplay";
import { GlobalContext } from "components/GlobalContext";
import { IColumnDefinition } from "components/SortableTable";
import IElt, { IEltCreateOrUpdate, IEltFilters, IEltInitResult } from "models/sql/IElt";
import { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import EltService from "services/EltService";

interface IEltsLookupProps {
    baseData?: IEltInitResult;
}

const EltsLookup = (props: IEltsLookupProps) => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const navigate = useNavigate();
    const [filter, setFilter] = useState<IEltFilters>({});
    const [forceRefresh, setForceRefresh] = useState(new Date());

    const getColumns = (): IColumnDefinition<IElt, IEltFilters>[] => {
        return [
            {
                propName: "code",
                title: "Code",
                customRenderer: (value, data) => <td className="align-top" key={`code${data.eltId}`}>
                    {value}
                </td>,
                sortable: true
            },
            {
                propName: "type",
                title: "Type",
                customRenderer: (value, data) => <td className="align-top" key={`type${data.eltId}`}>
                    {value}
                </td>,
                sortable: true
            },
            {
                propName: "redirects",
                title: "Uses",
                customRenderer: (value, data) => <td className="align-top" key={`redirects${data.eltId}`}>
                    {value}
                </td>,
                sortable: true
            },
            {
                propName: "eltId",
                title: "Department",
                customRenderer: (value, data) => <td className="align-top" key={`department${data.eltId}`}>
                    {data?.fireDepartment?.fireDeptName ?? data.manualFireDepartment}
                </td>
            },
            {
                propName: "eltId",
                title: "Station",
                customRenderer: (value, data) => <td className="align-top" key={`station${data.eltId}`}>
                    {data?.fireStation?.name ?? data.manualFireStation}
                </td>
            }
        ];
    };

    const getTools = () => [
        <>
            {
                globalContext.roles.some(r => r === "Web.Admin") &&
                <Button
                    key="createnew"
                    variant="success"
                    className="full-sm"
                    onClick={() => { navigate(`/Elts/Detail/`) }}>Create New</Button>
            }
        </>
    ];

    return (
        <CommonLookupDisplay<IEltFilters, IElt, IEltCreateOrUpdate>
            baseFilters={{
                sortBys: ["created"],
                sortDescending: true
            }}
            filterHints={{
                sortBys: "Array",
                sortDescending: "Boolean"
            }}
            dataTypeName="Elt"
            dataTypeNamePlural="Elts"
            pathName="Elts"
            primaryIdKey="eltId"
            className=""
            countriesFilterKey=""
            statesFilterKey=""
            filter={filter}
            forceReload={forceRefresh}
            setFilter={setFilter}
            columnDefinitions={getColumns()}
            service={EltService}
            tools={getTools()}
        />
    );
}

export default EltsLookup;
